import {Component, Injectable, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-BasicAuth',
    templateUrl: './BasicAuth.component.html'
})

@Injectable()
export class BasicAuthComponent implements OnInit {
    consumerID: string;
    anonymous: string;
    hideCredentials = false;

    constructor() { }

    data = {
        'consumerID': this.consumerID,
        'anonymous': this.anonymous,
        'hide_credentials': this.hideCredentials,
        'plugin': 'basic-auth'
    }

    slider() {
        this.hideCredentials = !this.hideCredentials;
    }

    BasicAuth() {
        // this.apiManagementInstance.sendGatewayBasicAuth();
    }

    ngOnInit() {
    }

}
